import { ButtonGroup } from "@components/button";
import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { DatePath } from "@pages/asset/fixedAsset/FixedAssetChangePriceDef";
import React from "react";

import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { TextAlign } from "../../../enums";
import BindingContext, { IEntity } from "../../../odata/BindingContext";
import { IFormStorageSaveResult, ISaveArgs } from "../../../views/formView/FormStorage";
import { FormViewForExtend, IFormViewProps } from "../../../views/formView/FormView";

export interface IFixedAssetChangePriceFormViewProps extends IFormViewProps<IEntity>{
    buttons?: React.ReactElement;
    summary?: React.ReactElement;
}

class FixedAssetChangePriceFormView extends FormViewForExtend<IEntity, IFixedAssetChangePriceFormViewProps> {

    get dateBc(): BindingContext {
        return this.props.storage.data.bindingContext.navigate(DatePath);
    }

    handleChange(e: ISmartFieldChange): void {
        super.handleChange(e);

        if (e.bindingContext.getPath() === BindingContext.localContext("Type")) {
            const { storage } = this.props;
            const dateBc = this.dateBc;
            storage.clearError(dateBc);
            storage.validateField(dateBc)
                .then(() => storage.refreshFields());
        }
    }

    async save(saveArgs?: Partial<ISaveArgs>): Promise<IFormStorageSaveResult> {
        // do nothing, form cannot be saved (redefine just to prevent shortcuts handling, etc...)
        return null;
    }

    renderFooter = () => {
        return (
                <ButtonGroup align={TextAlign.Right}>
                    {this.props.buttons}
                </ButtonGroup>
        );
    }
}

export default withPermissionContext(FixedAssetChangePriceFormView);